export const allowViewUserManagement = [
  "COMPANY ADMIN",
  "SUPER ADMIN",
  "ADMIN",
];

export const internalRoles = [
  { label: "User", value: "USER" },
  { label: "Admin", value: "ADMIN" },
];

export const externalRoles = [{ label: "User", value: "COMPANY USER" }];

export const allowedRoleSelect = ["SUPER ADMIN"];

export const statusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];

export const SHOWN_USER_ROLE = {
  "SUPER ADMIN": "Super Admin",
  "COMPANY ADMIN": "Admin",
  "COMPANY USER": "User",
};
